import state from './state.js'
import * as getters from './getters.js'

export default {
  state,
  getters
}
